export default __webpack_public_path__ + "static/media/logo-xtree.dd1cd6d3.svg";